import config from '@config';

export const gtmEvents = {
  promoClick: 'promo_click',
  registrationStart: 'registration_start',
  registrationSuccess: 'registration_success',
  loginSuccess: 'login_success',
  depositStart: 'deposit_start',
  depositSuccess: 'deposit_success',
  depositFail: 'deposit_fail',
  withdrawalStart: 'withdrawal_start',
  withdrawalSuccess: 'withdrawal_success',
  betPlaceSuccess: 'bet_place_success',
  betPlaceFail: 'bet_place_fail',
  searchTicketSubmit: 'search_ticket_submit',
  searchTicketScanOpen: 'search_ticket_scan_open',
  popularBadgeShown: 'popular_badge_shown',
  popularOutcomeAddedToSlip: 'popular_outcome_added_to_slip',
} as const;

export type GtmEventName = (typeof gtmEvents)[keyof typeof gtmEvents];

type GtmEventPayload = {
  value?: string | number;
  reason?: string;
  [key: string]: unknown;
};

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export function getGtmId() {
  return config.googleTagManagerID?.trim() || '';
}

export function trackGtmEvent(event: GtmEventName, payload: GtmEventPayload = {}) {
  if (typeof window === 'undefined') {
    return;
  }
  if (!getGtmId()) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...payload,
  });
}

export function trackPageView(path: string, search = '') {
  if (typeof window === 'undefined' || !getGtmId()) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'page_view',
    page_path: `${path}${search}`,
    page_location: window.location.href,
    page_title: document.title,
  });
}
